import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
    selector: 'app-installer-quotes-sent',
    templateUrl: './installer-quotes-sent.component.html',
    styleUrls: ['./installer-quotes-sent.component.scss'],
    standalone: false
})
export class InstallerQuotesSentComponent extends ListRendererWidgetBase {}
